import { observer } from 'mobx-react-lite';
import type { ReactNode } from 'react';
import { SLASH_COMMANDS } from 'src/constants/slashCommands';
import { useAuthStore } from 'src/stores/AuthStore/AuthStore';
import CheckUpgradeRequired from '../check-upgrade-required/CheckUpgradeRequired';

interface SourceModuleAccessProps {
  children: ReactNode;
}

/**
 * Revamp Sources are governed by the server's Source capability contract.
 * The legacy Memory module keeps its existing plan-action guard unchanged.
 */
const SourceModuleAccess = observer(({ children }: SourceModuleAccessProps) => {
  const { isRevampExperience } = useAuthStore();

  if (isRevampExperience()) {
    return <>{children}</>;
  }

  return (
    <CheckUpgradeRequired featureId={SLASH_COMMANDS.memory}>
      {children}
    </CheckUpgradeRequired>
  );
});

export default SourceModuleAccess;
